import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { MoveRight } from "lucide-react";
import InfiniteScroll from "../components/InfiniteScroll";

import LandingPage1 from "../images/LandingPage1.png";
import LandingPage2 from "../images/LandingPage2.png";
import LandingPage3 from "../images/LandingPage3.png";
import LandingPage4 from "../images/LandingPage4.jpg";

import AsiaGaugelogo from "../images/AsiaGaugeLogo.png";
import CommonLogo from "../images/CommonLogo.png";
import DelValLogo from "../images/DelValLogo.png";
import EskaValve from "../images/EskaValve.png";
import GiacominiValve from "../images/GiacominiValveLogo.png";

import ConsultationImage from "../images/Consultation.jpg";
import GasEquipments from "../images/GasEquipments.jpg";
import Installation from "../images/Installation.jpg";
import SiteVisit from "../images/SiteVisit.jpg";
import SpareParts from "../images/SpareParts.jpg";

import PressureGauge from "../images/productPressureGauge.png";
import GasMeter from "../images/productGasMeter.png";
import BallValve from "../images/productBallValve.png";
import PressureRegulator from "../images/productGasRegulator.png";
import GasFilter from "../images/productGasFilter.jpeg";
import GasHose from "../images/productGasHose.png";

import GasPipe from "../images/GasPipe.jpg";
import { Link } from "react-router-dom";

import { LuHandshake } from "react-icons/lu";
import { SlSpeedometer } from "react-icons/sl";
import { GrDocumentVerified } from "react-icons/gr";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const Home = () => {
  const [endState, setEndState] = useState(false);

  const serviceCarouselRef = useRef(null);
  const productCarouselRef = useRef(null);
  const [itemWidth, setItemWidth] = useState(0);
  const itemRef = useRef(null);

  const [isServiceScrolledToStart, setIsServiceScrolledToStart] =
    useState(true);
  const [isProductScrolledToStart, setIsProductScrolledToStart] =
    useState(true);
  const [isServiceScrolledToEnd, setIsServiceScrolledToEnd] = useState(false);
  const [isProductScrolledToEnd, setIsProductScrolledToEnd] = useState(false);

  const checkScrollPosition = (ref, setStartState, setEndState) => {
    if (ref.current) {
      setStartState(ref.current.scrollLeft === 0);

      const maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;
      setEndState(ref.current.scrollLeft >= maxScrollLeft - 1);
    }
  };

  useEffect(() => {
    if (serviceCarouselRef.current) {
      serviceCarouselRef.current.addEventListener("scroll", () =>
        checkScrollPosition(
          serviceCarouselRef,
          setIsServiceScrolledToStart,
          setIsServiceScrolledToEnd
        )
      );
    }
    if (productCarouselRef.current) {
      productCarouselRef.current.addEventListener("scroll", () =>
        checkScrollPosition(
          productCarouselRef,
          setIsProductScrolledToStart,
          setIsProductScrolledToEnd
        )
      );
    }

    return () => {
      if (serviceCarouselRef.current) {
        serviceCarouselRef.current.removeEventListener("scroll", () =>
          checkScrollPosition(
            serviceCarouselRef,
            setIsServiceScrolledToStart,
            setIsServiceScrolledToEnd
          )
        );
      }
      if (productCarouselRef.current) {
        productCarouselRef.current.removeEventListener("scroll", () =>
          checkScrollPosition(
            productCarouselRef,
            setIsProductScrolledToStart,
            setIsProductScrolledToEnd
          )
        );
      }
    };
  }, []);

  useEffect(() => {
    if (itemRef.current) {
      setItemWidth(itemRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (serviceCarouselRef.current) {
      serviceCarouselRef.current.addEventListener("scroll", () =>
        checkScrollPosition(
          serviceCarouselRef,
          setIsServiceScrolledToStart,
          setIsServiceScrolledToEnd
        )
      );
    }
    if (productCarouselRef.current) {
      productCarouselRef.current.addEventListener("scroll", () =>
        checkScrollPosition(
          productCarouselRef,
          setIsProductScrolledToStart,
          setIsProductScrolledToEnd
        )
      );
    }

    return () => {
      if (serviceCarouselRef.current) {
        serviceCarouselRef.current.removeEventListener("scroll", () =>
          checkScrollPosition(
            serviceCarouselRef,
            setIsServiceScrolledToStart,
            setIsServiceScrolledToEnd
          )
        );
      }
      if (productCarouselRef.current) {
        productCarouselRef.current.removeEventListener("scroll", () =>
          checkScrollPosition(
            productCarouselRef,
            setIsProductScrolledToStart,
            setIsProductScrolledToEnd
          )
        );
      }
    };
  }, []);

  const scroll = (ref, direction, itemWidth) => {
    if (ref.current) {
      const scrollAmount = itemWidth || ref.current.clientWidth * 0.8; // Default to 80% width for desktop
      ref.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  

  const services = [
    {
      title: "Consultation",
      icon: LuHandshake,
      description:
        "Expert guidance on gas equipments for homes and businesses.",
      image: ConsultationImage,
    },
    {
      title: "Gas Equipments",
      icon: SlSpeedometer,
      description:
        "Supply high-quality gas equipments for residential and commercial applications.",
      image: GasEquipments,
    },
    {
      title: "Site Assessment",
      icon: GrDocumentVerified,
      description:
        "Comprehensive evaluations to determine the best gas solutions for your needs.",
      image: SiteVisit,
    },
    // {
    //   title: "Spare Parts",
    //   description:
    //     "Reliable spare parts for boilers, burners, and gas equipment.",
    //   image: SpareParts,
    // },
  ];

  const products = [
    {
      title: "Pressure Gauge",
      image: PressureGauge,
    },
    {
      title: "Gas Meter",
      image: GasMeter,
    },
    {
      title: "Ball Valve",
      image: BallValve,
    },
    {
      title: "Pressure Regulator",
      image: PressureRegulator,
    },
    {
      title: "Gas Filter",
      image: GasFilter,
    },
    {
      title: "Gas Hose",
      image: GasHose,
    },
  ];

  // const [partners, setPartners] = useState([]);
  // useEffect(() => {
  //   const fetchPartners = async () => {
  //     try {
  //       const response = await axios.get(`${API_BASE_URL}/partners`);
  //       setPartners(
  //         response.data.map((p) => ({
  //           name: p.companyName,
  //           logo: p.photos?.[0]?.data || "/placeholder.png",
  //         }))
  //       );
  //     } catch (err) {
  //       console.error("Failed to fetch partners", err);
  //     }
  //   };

  //   fetchPartners();
  // }, []);

  const partners = [
    { name: "Asia Gauge", logo: AsiaGaugelogo },
    { name: "Common Valve", logo: CommonLogo },
    { name: "Del Valve", logo: DelValLogo },
    { name: "Eska Valve", logo: EskaValve },
    { name: "Giacomini Valve", logo: GiacominiValve }
  ];
  
  return (
    <div className="mt-6 md:mt-0 w-full overflow-x-hidden">
      <div className="w-full bg-white">
        {/* Content Wrapper */}
        <div className="w-full py-6 md:px-12 px-6">
          <div className="mx-auto grid md:grid-cols-2 gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="text-center md:text-left">
              <p className="text-blue-600 font-semibold uppercase text-lg">
                Efficient. Quality. Reliable.
              </p>
              <h1 className="text-5xl md:text-7xl font-bold text-gray-900 leading-tight mt-3">
                Your Trusted Gas Equipments Partner
              </h1>
              <p className="text-xl text-gray-600 mt-5">
                Delivering safe, reliable, and efficient gas solutions for homes
                and industries.
              </p>

              {/* Buttons */}
              <div className="md:w-3/4 w-full mt-7 flex flex-col md:flex-row gap-4 mx-auto md:mx-0 justify-center md:justify-start items-center md:items-start">
                <Link to="/contact" className="w-full md:w-1/2">
                  <button className="w-full bg-gradient-to-br from-blue-800 to-blue-400 text-white px-10 py-4 rounded-full font-semibold">
                    Contact us
                  </button>
                </Link>
                <div className="w-full md:w-1/2 md:mt-0 rounded-full p-[2px] bg-gradient-to-br from-blue-400 to-blue-800">
                  <Link to="/contact" className="w-full md:w-1/2">
                    <button className="w-full bg-white text-blue-800 px-10 py-4 rounded-full font-semibold">
                      About us
                    </button>
                  </Link>
                </div>
              </div>
              {/* Stats Section */}
            </div>

            {/* Right Side - Image Column */}
            <div className="flex gap-4">
              <div className="flex flex-col gap-4">
                <img
                  src={LandingPage1}
                  className="md:w-full h-[250px] md:h-[200px] rounded-xl object-cover"
                  alt="Oil Rig"
                />
                <img
                  src={LandingPage3}
                  className="md:w-full h-[200px] md:h-[400px] rounded-xl object-cover"
                  alt="Refinery"
                />
              </div>
              <div className="flex flex-col gap-4">
                <img
                  src={LandingPage2}
                  className="md:w-full h-[200px] md:h-[400px] rounded-xl object-cover"
                  alt="Gas Pipeline"
                />
                <img
                  src={LandingPage4}
                  className="md:w-full h-[250px] md:h-[200px] rounded-xl object-cover"
                  alt="Engineer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 md:px-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-white mt-5">
        {[
          {
            number: "15+",
            label: "Years of Experience",
            description: "Decades of expertise delivering top-tier services.",
          },
          {
            number: "1.5K+",
            label: "Happy Clients",
            description:
              "Trusted by thousands for exceptional service quality.",
          },
          {
            number: "50+",
            label: "Certified Professionals",
            description: "A highly skilled team ensuring seamless solutions.",
          },
        ].map((stat, index) => (
          <div
            key={index}
            className="flex flex-col bg-gradient-to-br from-blue-800 to-blue-300 p-6 rounded-2xl shadow-lg transition-transform transform hover:scale-105"
          >
            <span className="text-4xl font-bold text-white">{stat.number}</span>
            <span className="text-lg font-semibold mt-2">{stat.label}</span>
            <span className="text-gray-300 mt-1">{stat.description}</span>
          </div>
        ))}
      </div>

      {/* Partners Section */}
      <div className="px-6 md:px-12 lg:flex items-center text-2xl md:text-3xl font-semibold gap-2 mt-14">
        <div className="">
          <h2 className="text-blue-600 text-base font-bold tracking-widest">
            OUR PARTNERS
          </h2>
          <p className="text-gray-900 text-3xl md:text-4xl font-semibold leading-snug">
            We partner with the best
          </p>
        </div>
        <div className="mt-5 lg:mt-0 ml-auto">
          <Link
            to="/partners"
            className="flex items-center gap-2 text-lg text-blue-950 hover:text-blue-800 transition-all font-medium"
          >
            View Partners <MoveRight size={20} />
          </Link>
        </div>
      </div>

      <div className="w-full h-full">
        {partners.length > 0 && <InfiniteScroll partners={partners} />}
      </div>

      {/* Services Section */}
      <div className="px-6 md:px-12 relative mt-8 md:mt-20">
        <div className="w-full">
          {/* Title */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-12 md:mb-7">
            <div className="md:max-w-[40%]">
              <h2 className="text-blue-600 text-base font-bold tracking-widest">
                WHAT WE DO
              </h2>
              <p className="text-gray-900 text-3xl md:text-4xl font-semibold leading-snug">
                Reliable Solution For Your Needs
              </p>
            </div>
            <div className="text-gray-600 text-base leading-relaxed md:max-w-[45%]">
              As our motto, we always provide the best service and gas equipment
              for you, so that you don’t have to worry.
            </div>
          </div>

          {/* Scrollable Carousel with Buttons */}
          {/* Left Button */}
          {/* {!isServiceScrolledToStart && (
            <button
              onClick={() => scroll(serviceCarouselRef, "left", itemWidth)}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-md hover:bg-gray-900 transition-all duration-300 hover:scale-110 focus:outline-none z-20"
            >
              <ChevronLeft size={28} />
            </button>
          )} */}
          {/* Carousel */}
          {/* <div className="overflow-x-auto no-scrollbar"> */}
          <div>
            {/* <div
              ref={serviceCarouselRef}
              className="flex gap-8 snap-x snap-mandatory scroll-smooth items-stretch"
            > */}
            <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 w-full">
              {services.map((service, index) => (
                <div
                  key={index}
                  ref={index === 0 ? itemRef : null}
                  className="pb-6 pt-6 flex flex-col"
                >
                  {/* <div
                    className={`mb-4 p-4 rounded-xl w-fit ${
                      service.title === "Consultation"
                        ? "bg-blue-100"
                        : service.title === "Gas Equipment"
                        ? "bg-green-100"
                        : service.title === "Site Assessment"
                        ? "bg-blue-100"
                        : "bg-green-100"
                    }`}
                  >
                    <service.icon
                      className={`text-3xl ${
                        service.title === "Consultation"
                          ? "text-blue-600"
                          : service.title === "Gas Equipment"
                          ? "text-green-600"
                          : service.title === "Site Assessment"
                          ? "text-blue-600"
                          : "text-green-600"
                      }`}
                    />
                  </div> */}
                  <img className="rounded-t-lg h-72" src={service.image}></img>
                  <div className="border p-7 rounded-b-2xl">
                    <h3 className="text-2xl font-semibold mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-base">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Button */}
          {/* {!isServiceScrolledToEnd && (
            <button
              onClick={() => scroll(serviceCarouselRef, "right", itemWidth)}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-md hover:bg-gray-900 transition-all duration-300 hover:scale-110 focus:outline-none z-20"
            >
              <ChevronRight size={28} />
            </button>
          )} */}
        </div>
      </div>

      {/* Products */}
      <div className="relative mt-10 md:mt-15">
        <div className="w-full">
          {/* Title */}
          <div className="mb-6 px-6 md:px-12 lg:flex font-semibold items-center text-2xl md:text-3xl gap-2">
            <div className="">
              <h2 className="text-blue-600 text-base font-bold tracking-widest">
                OUR PRODUCTS
              </h2>
              <p className="text-gray-900 text-3xl md:text-4xl font-semibold leading-snug">
                Wide Range Of Quality Gas Equipments
              </p>
            </div>
            <div className="mt-5 lg:mt-0 ml-auto">
              <Link
                to="/products"
                className="flex items-center gap-2 text-lg text-blue-950 hover:text-blue-800 transition-all font-medium"
              >
                View Products <MoveRight size={20} />
              </Link>
            </div>
          </div>

          {/* Scrollable Carousel with Buttons */}
          {/* Left Button */}
          <div className="relative w-full">
            {/* Left Button */}
            {/* {!isProductScrolledToStart && (
              <button
                onClick={() => scroll(productCarouselRef, "left", itemWidth)}
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-md hover:bg-gray-900 transition-all duration-300 hover:scale-110 focus:outline-none z-20 md:left-4"
              >
                <ChevronLeft size={28} />
              </button>
            )} */}

            {/* Carousel */}
            <div className="overflow-x-auto no-scrollbar w-full">
              <div
                className="flex snap-x snap-mandatory gap-8 scroll-smooth items-start my-5"
                ref={productCarouselRef}
              >
                {products.map((product, index) => (
                  <div
                    key={index}
                    className={`bg-white rounded-3xl border shadow-md hover:scale-105 transition-transform hover:shadow-xl transition-shadow flex-shrink-0 w-[300px] md:w-[350px] snap-start mb-5 flex flex-col ${
                      index === 0 ? "ml-6 md:ml-12" : ""
                    }`}
                  >
                    <div className="p-5 flex-grow">
                      <p className="text-2xl font-medium text-center">
                        {product.title}
                      </p>
                    </div>
                    <div className="p-5">
                      {product.image && (
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full h-72 rounded-b-3xl object-contain"
                        />
                      )}
                    </div>
                  </div>
                ))}
                <div className="flex-shrink-0 w-[6rem] md:w-[12rem] snap-end" />
              </div>
            </div>

            {/* Right Button */}
            {/* {!isProductScrolledToEnd && (
              <button
                onClick={() => scroll(productCarouselRef, "right", itemWidth)}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-md hover:bg-gray-900 transition-all duration-300 hover:scale-110 focus:outline-none z-20 md:right-4"
              >
                <ChevronRight size={28} />
              </button>
            )} */}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mt-6 flex flex-col items-center mb-2">
        <div
          className="w-full h-72 relative bg-cover bg-center py-16 px-6"
          style={{ backgroundImage: `url(${GasPipe})` }}
        >
          {/* Dark Overlay for Better Readability */}
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>

          {/* Text Content */}
          <div className="relative text-center text-white max-w-3xl mx-auto">
            <h2 className="lg:text-4xl text-3xl font-bold">
              Get the Best Gas Equipment Services
            </h2>
            <p className="text-lg mt-2">
              Fill in your details, and we’ll get back to you shortly!
            </p>
          </div>
        </div>
        <div className="w-full flex justify-center mt-[-80px] lg:mt-[-110px]">
          <div className="w-5/6 md:w-4/6 bg-white rounded-2xl p-8 relative border drop-shadow-md">
            {/* Form Fields */}
            <div className="w-full flex flex-col lg:flex-row lg:space-x-6">
              {/* Full Name */}
              <div className="w-full">
                <label className="block text-gray-700 text-lg font-medium mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name..."
                  className="w-full p-4 border border-gray-300 rounded-xl transition-all placeholder-gray-400"
                />
              </div>

              {/* Phone Number */}
              <div className="w-full mt-4 lg:mt-0">
                <label className="block text-gray-700 text-lg font-medium mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  placeholder="Enter your phone number..."
                  className="w-full p-4 border border-gray-300 rounded-xl transition-all placeholder-gray-400"
                />
              </div>
            </div>

            {/* CTA Button */}
            <button className="w-full mt-6 text-white font-semibold py-4 rounded-xl bg-gradient-to-br from-blue-800 to-blue-400 transition-all shadow-lg">
              Request a Consultation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
